import { type components } from '~/content-api/schema';

export type ResponsiveProperty<T> = T | ResponsivePropertyObject<T>;

export type ResponsivePropertyObject<T> = {
  default?: T | null;
  sm?: T | null;
  md?: T | null;
  lg?: T | null;
  xl?: T | null;
  xxl?: T | null;
};

export type ResponsivePropertyObjectPopulated<T> = {
  default: T;
  sm: T;
  md: T;
  lg: T;
  xl: T;
  xxl: T;
};

export function getResponsiveValues<T>(
  properties: ResponsiveProperty<T>,
  defaultFallbackValue: T,
): ResponsivePropertyObjectPopulated<T> {
  if (
    typeof properties === 'object' &&
    properties !== null &&
    properties !== undefined &&
    'default' in properties
  ) {
    const defaultValue = properties.default ?? defaultFallbackValue;
    const sm = properties.sm ?? defaultValue;
    const md = properties.md ?? sm;
    const lg = properties.lg ?? md;
    const xl = properties.xl ?? lg;
    const xxl = properties.xxl ?? xl;

    return {
      default: defaultValue,
      sm,
      md,
      lg,
      xl,
      xxl,
    };
  }

  return {
    default: defaultFallbackValue,
    sm: defaultFallbackValue,
    md: defaultFallbackValue,
    lg: defaultFallbackValue,
    xl: defaultFallbackValue,
    xxl: defaultFallbackValue,
  };
}

/**
 * Get responsive integer item
 *
 * Use this to pull out the responsive integer properties from a block list model
 */
export function getResponsiveIntegerItem(
  property: components['schemas']['ApiBlockListModel'],
) {
  const item = property.items.find(
    (item) => item.content.contentType === 'blockResponsivePropertiesInteger',
  );

  return item?.content.contentType === 'blockResponsivePropertiesInteger'
    ? item.content.properties
    : null;
}

export function getResponsiveNumberItem(
  property: components['schemas']['ApiBlockListModel'],
) {
  const item = property.items.find(
    (item) => item.content.contentType === 'blockResponsivePropertiesNumber',
  );

  return item?.content.contentType === 'blockResponsivePropertiesNumber'
    ? item.content.properties
    : null;
}
